import { render } from "./ParentTabComponent.vue?vue&type=template&id=6ad54745"
import script from "./ParentTabComponent.vue?vue&type=script&lang=js"
export * from "./ParentTabComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__